module.exports = __webpack_public_path__ + "static/media/operational_optimization.5f383936.svg";